import { Layout } from "antd";
import Footer from "./Footer";

const { Content } = Layout;

const PublicLayout = ({ children, onClickFooter, withFooter, ...props }) => {
  const shouldRenderFooter = withFooter !== undefined ? withFooter : true;

  return (
    <Layout className="h-screen" {...props}>
      <Content className="flex items-center justify-center flex-col">
        {children}
      </Content>
      {shouldRenderFooter && <Footer onClick={onClickFooter} />}
    </Layout>
  );
};

export default PublicLayout;
